import { LoadingState } from "@/components/ui/status-state";

/** Fallback shown while the create page loads. */
export function CreatePageLoaderFallback() {
  return (
    <div className="app-route-background min-h-screen flex items-center justify-center p-8">
      <LoadingState
        title="Loading..."
        description="Getting your designer ready…"
        size="lg"
        variant="card"
        className="w-full max-w-4xl rounded-3xl bg-card p-12 shadow-xl"
        contentClassName="max-w-xl"
        spinnerClassName="text-primary"
      />
    </div>
  );
}
